const selectedFiltersUI = () => {
    const filterResultsHolder = document.querySelector('.filter-results-list-holder');
    const clearAllBtn = document.getElementById('clear-all');
    if (!filterResultsHolder || !clearAllBtn) return;

    const filterGroups = document.querySelectorAll('.filter-group');

    const updateAllUI = () => {
        // Удалить все видимые .item-result
        filterResultsHolder.querySelectorAll('.item-result').forEach(el => el.remove());

        filterGroups.forEach(group => {
            const checkboxes = group.querySelectorAll('input[type="checkbox"]');
            const selectedCheckboxes = Array.from(checkboxes).filter(cb => cb.checked);
            const counterSpan = group.querySelector('.input-text');

            // Обновить счётчик
            if (counterSpan) {
                counterSpan.textContent = selectedCheckboxes.length;
            }

            // Добавить выбранные категории в .filter-results-list
            selectedCheckboxes.forEach(cb => {
                const label = cb.parentElement.textContent.trim();
                const taxonomy = cb.name.replace(/\[\]$/, '');

                const item = document.createElement('div');
                item.className = 'item-result';
                item.dataset.taxonomy = taxonomy;
                item.dataset.value = cb.value;
                item.textContent = label;

                const closeBtn = document.createElement('span');
                closeBtn.innerHTML = '<img src="/wp-content/themes/coolmedia/src/img/cross.svg" alt="Cross">';
                closeBtn.addEventListener('click', () => {
                    cb.checked = false;
                    updateAllUI();
                    triggerFormSubmit();
                });

                item.appendChild(closeBtn);
                filterResultsHolder.appendChild(item);
            });
        });
    };

    // Clear All
    clearAllBtn.addEventListener('click', () => {
        filterGroups.forEach(group => {
            const checkboxes = group.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(cb => cb.checked = false);
            const counterSpan = group.querySelector('.input-text');
            if (counterSpan) counterSpan.textContent = '0';
        });
        updateAllUI();
        triggerFormSubmit();
    });

    // Обработчики на каждый чекбокс
    filterGroups.forEach(group => {
        const checkboxes = group.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                updateAllUI();
                triggerFormSubmit();
            });
        });
    });

    updateAllUI(); // первичная инициализация
};

const triggerFormSubmit = () => {
    const form = document.getElementById('filter-form');
    if (form) {
        form.dispatchEvent(new Event('submit'));
    }
};

export default selectedFiltersUI;
